import { Injectable } from '@angular/core';

import { filterSportsEmitLast } from '@frontend/sports/host-app/sports-product/feature/utils';
import { BehaviorSubject, Observable } from 'rxjs';

import { BreadcrumbModel } from './breadcrumb.models';
import { BreadcrumbRouteVisibilityService } from './breadcrumbs-visibility.service';

export interface Breadcrumbs {
    breadcrumbs: BreadcrumbModel[];
    visible: boolean;
}

@Injectable({ providedIn: 'root' })
export class BreadcrumbsService {
    LEAGUE_TYPES = {
        league: [4, 7, 11, 12, 16, 18, 21, 22, 23, 27, 28, 31, 32, 36, 49, 52, 60, 61, 62, 70, 71, 88],
        tournament: [5, 13, 24, 33, 34, 35, 38, 44, 45, 47, 48, 50, 53, 56, 58, 63, 67, 68, 69, 74, 75, 76, 77, 87, 90, 93],
        race: [6, 10, 14, 15, 29, 30, 37, 39, 40, 41, 42, 43, 46, 51, 54, 55, 91],
        competition: [9, 17, 26, 57, 59, 64, 65, 66, 72, 73, 78, 89, 80, 81, 82, 83, 84, 85, 86, 89, 92, 94, 95, 96, 100],
    };

    // View details
    types = {
        AZ: 'AZ',
        REGION: 'REGION',
        SPORT: 'SPORT',
        LEAGUE: 'LEAGUE',
        TOPLEAGUE: 'TOPLEAGUE',
        FILTER: 'FILTER',
    };

    private _breadcrumbs$ = new BehaviorSubject<Breadcrumbs>({ breadcrumbs: [], visible: false });

    constructor(private breadcrumbVisibility: BreadcrumbRouteVisibilityService) {
        this.breadcrumbVisibility.visibility$.pipe(filterSportsEmitLast()).subscribe(this.onBreadcrumbVisibilityChange);
    }

    get breadcrumbs$(): Observable<Breadcrumbs> {
        return this._breadcrumbs$.asObservable();
    }

    setBreadcrumbs(breadcrumbs: BreadcrumbModel[]): void {
        this._breadcrumbs$.next({ breadcrumbs, visible: this.breadcrumbVisibility.isVisible(breadcrumbs) });
    }

    private onBreadcrumbVisibilityChange = (): void => {
        const breadcrumbs = this._breadcrumbs$.value.breadcrumbs;
        this.setBreadcrumbs(breadcrumbs);
    };
}
